(function () {
  'use strict';

  function handleUpsell(e) {
    var target = e.target;

    // Size select change — enable/disable Add button
    if (target.matches('[data-upsell-select]')) {
      e.stopPropagation();
      var card = target.closest('[data-upsell-card]');
      if (!card) return;
      var btn = card.querySelector('[data-upsell-add]');
      if (!btn) return;
      btn.disabled = !target.value;
      btn.dataset.variantId = target.value;
      return;
    }

    // Add button click
    var addBtn = target.closest('[data-upsell-add]');
    if (!addBtn || addBtn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    var card = addBtn.closest('[data-upsell-card]');
    var productTitle = card ? card.querySelector('.cart-upsell__title') : null;
    var titleText = productTitle ? productTitle.textContent.trim() : 'Item';

    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    // Step 1: Add to cart
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add';
          return;
        }

        // Announce for assistive tech
        var live = document.getElementById('CartUpsellLive');
        if (live) live.textContent = titleText + ' added to your bag';

        // Step 2: Fetch fresh cart drawer section and swap HTML
        return fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function (r) {
        if (!r) return;
        return r.json();
      })
      .then(function (sections) {
        if (!sections) return;

        // Replace cart drawer HTML
        if (sections['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('#CartDrawer');
          var currentDrawer = document.querySelector('#CartDrawer');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }

        // Update cart icon bubble
        if (sections['cart-icon-bubble']) {
          var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('.shopify-section');
          var currentBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }

        // Remove is-empty class
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('is-empty')) {
          drawer.classList.remove('is-empty');
        }
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Add';
      });
  }

  function handleArrow(e) {
    var arrow = e.target.closest('[data-upsell-arrow]');
    if (!arrow) return;
    var track = document.getElementById('CartUpsellTrack');
    if (!track) return;
    var dir = arrow.dataset.upsellArrow === 'prev' ? -1 : 1;
    var scrollAmt = track.offsetWidth * 0.7;
    track.scrollBy({ left: dir * scrollAmt });
  }

  // Stop change events from reaching cart-drawer-items' quantity handler
  document.addEventListener('change', function (e) {
    if (e.target.closest('.cart-upsell')) {
      e.stopImmediatePropagation();
      // Handle size select inline
      var target = e.target;
      if (target.matches('[data-upsell-select]')) {
        var card = target.closest('[data-upsell-card]');
        if (!card) return;
        var btn = card.querySelector('[data-upsell-add]');
        if (!btn) return;
        btn.disabled = !target.value;
        btn.dataset.variantId = target.value;
      }
    }
  }, true);

  document.addEventListener('click', function (e) {
    handleUpsell(e);
    handleArrow(e);
  });
})();
